/**
 * Centralized environment configuration with fallback values
 */
const config = window._env_ || {};
/*
// Debug: print all environment variables
console.log('=== Environment Variables ===');
console.log('REACT_APP_API_URL:', config.REACT_APP_API_URL);
console.log('REACT_APP_AUTO_SECURITY_ENABLE:', config.REACT_APP_AUTO_SECURITY_ENABLE);
console.log('==========================');
*/


const getBaseUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost/auth';
  }
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.host}/auth`;
};

const getDefaultApiUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:8080/api';
  }
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.host}/api`;
};

const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) {
    return getDefaultApiUrl();
  }
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
};

const normalizeBasePath = (basePath) => {
  if (!basePath) {
    return '/v1';
  }
  return basePath.startsWith('/') ? basePath : `/${basePath}`;
};

const env = {
  /**
   * Whether to use Keycloak authentication
   * Fallback to true if not set
   */
  useKeycloakAuth: config.REACT_APP_AUTO_SECURITY_ENABLE
  ? config.REACT_APP_AUTO_SECURITY_ENABLE.toLowerCase() === 'true'
  : true,

  /**
   * Application version from environment variable
   * Fallback to package.json version if not set
   */
  version: config.AUTOMATE_VERSION,

  /**
   * Keycloak configuration
   */
  keycloak: {
    baseUrl: config.KC_BASE_URL ?? getBaseUrl(),
    realm: config.KC_REALM || 'automate',
    clientId: config.KC_REALM_CLIENT || 'automate-fe'
  },

  /**
   * API configuration
   */
  api: {
    baseUrl: normalizeBaseUrl(config.REACT_APP_API_URL),
    basePath: normalizeBasePath(config.REACT_APP_API_BASE_PATH || '/v1')
  }
};

export default env;
